import { createStyles, rem } from '@mantine/core';
import bgDesktop from '../../../assets/images/bgDesktop.png';
import bgMobile from '../../../assets/images/bgMobile.png';

const useStyles = createStyles((theme) => ({
  wrapper: {
    // height: '100vh',
    backgroundSize: 'cover',
    backgroundImage: `url(${bgDesktop}), linear-gradient(121.51deg, ${theme.colors.tertiary[0]} 30.38%, ${theme.colors.tertiary[0]} 53.04%, #D6EBF0 71.29%)`,
    backgroundAttachment: 'fixed',
    backgroundPosition: 'inherit',
    [theme.fn.smallerThan('sm')]: {
      backgroundSize: 'auto',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${bgMobile}), linear-gradient(121.51deg, ${theme.colors.tertiary[0]} 30.38%, ${theme.colors.tertiary[0]} 53.04%, #D6EBF0 71.29%)`,
      padding: 20,
      paddingBottom: 250
    },
    padding: 50,
    paddingLeft: 140,
    paddingRight: 90,
    paddingBottom: 197
  },

  Headerwrapper: {
    width: '55%',
    marginLeft: '45%',
    display: 'flex',
    justifyContent: 'left',
    columnGap: '45%',
    marginTop: 20,
    marginBottom: 20,

    [theme.fn.smallerThan(1000)]: {
      width: '100%',
      marginLeft: 0,
      justifyContent: 'space-between',
      columnGap: 0,
      paddingLeft: 20,
      paddingRight: 20
    }
  },
  btn: {
    background: theme.colors.secondary[0],
    fontFamily: `Light, ${theme.fontFamily}`,
    height: 45,
    fontSize: 12,
    letterSpacing: 1,
    width: 100,

    ':hover': {
      background: theme.colors.primary[0]
    }
  },
  formContainer: {
    backgroundColor: 'transparent'
  },

  form: {
    width: 500,
    [theme.fn.smallerThan('sm')]: {
      width: '100%'
    },
    backgroundColor: 'transparent'
  },

  formContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  textInput: {
    background: '0 0',
    color: 'white',
    paddingBottom: '0px',
    paddingLeft: '0px',
    marginBottom: '0px',
    minWidth: 250,
    input: {
      paddingLeft: 0
    }
  },
  text: {
    fontFamily: `Regular, ${theme.fontFamily}`,

    paddingRight: '15px'
  },

  signupButton: {
    width: 120,
    fontSize: 16,
    backgroundColor: `${theme.colors.primary[0]}`,
    [theme.fn.smallerThan(600)]: {
      width: '100%',
      textAlign: 'center'
    },
    ':hover': {
      background: '#1D5E6D'
    }
  },
  loginWrapper: {
    display: 'flex',
    justifyContent: 'end',

    [theme.fn.smallerThan('sm')]: {
      display: 'none'
    }
  },

  loginWrapperMobile: {
    [theme.fn.largerThan(600)]: {
      display: 'none'
    },
    [theme.fn.smallerThan(600)]: {
      marginTop: 150
    }
  },
  loginButtonMobile: {
    width: rem(270),
    margin: 'auto',
    [theme.fn.smallerThan(600)]: {
      width: '100%'
    },
    ':hover': {
      background: theme.colors.primary[0]
    }
  },
  forgot: {
    textAlign: 'right',
    width: '100%',
    fontFamily: `Regular , ${theme.fontFamily}`,

    color: theme.colors.primary[0],
    marginTop: 10
  },
  loader: {
    position: 'fixed',
    top: '50%',
    left: '40%',
    zIndex: '1000',

    [theme.fn.largerThan('xs')]: {
      left: '23%'
    }
  }
}));
export default useStyles;
